// TODO: Waterwalls need to be modified to have an ID in order to be usable by GeckoFeature

/**
 * GeckoFeature class is the base class that is used by Asset Model.
 * It is designed to be an abstract class that is extended by other classes
 */
export class GeckoFeature {
  id: string

  /**
   * Constructor for the base GeckoFeature class. This class should not
   * be instantiated on its own, but should instead be extended
   * @param id
   */
  constructor(id: string) {
    if (this.constructor === GeckoFeature) {
      throw new Error(
        'Abstract Class GeckoFeature is not designed to be instantiated directly'
      )
    }
    this.id = id
  }
}
